// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.delete.RentalManagerUserPropertyDeleteV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyDeleteV2RequestDto } from '../..';

export const RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Path = '/api/web/v2/users/properties/delete';

/**
 * Delete a property
 */
export const RentalManagerUserPropertyDeleteV2WebApiHandler_delete = (
  postData: UserPropertyDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyDeleteV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
